import script from "./index-popular.vue?vue&type=script&setup=true&lang=js"
export * from "./index-popular.vue?vue&type=script&setup=true&lang=js"

import "./index-popular.vue?vue&type=style&index=0&id=6b22a2bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b22a2bc"]])

export default __exports__